import { render, staticRenderFns } from "./WarrantyActivated.vue?vue&type=template&id=6cf97ef9&scoped=true"
import script from "./WarrantyActivated.vue?vue&type=script&lang=js"
export * from "./WarrantyActivated.vue?vue&type=script&lang=js"
import style0 from "./WarrantyActivated.vue?vue&type=style&index=0&id=6cf97ef9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf97ef9",
  null
  
)

export default component.exports